<template>
  <button class="btn customisation-option" :style="{backgroundColor: color+'!important'}" v-on:click="clicked"></button>
</template>

<script>

  export default {
    name: "CustomisationColorButton",
    components: {},
    props: {
      color: String,
    },
    data() {
      return {}
    },
    computed: {},

    mixins: [],
    methods: {
      clicked() {
        this.$emit("clicked", this.color);
      }
    },
    mounted() {

    },
    created() {

    }
  }


</script>

<style lang="scss" scoped>

  @mixin aspect-ratio($width, $height) {
    position: relative;
    &:before {
      display: block;
      content: "";
      width: 100%;
      padding-top: ($height / $width) * 100%;
    }
    > .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  .customisation-option {
    @include aspect-ratio(1, 1);

    -webkit-mask: url("~@/assets/image/customise/color/bb_color_option.svg") no-repeat 100% 100%;
    mask: url("~@/assets/image/customise/color/bb_color_option.svg") no-repeat 100% 100%;
    background-color: yellow;
  }


</style>